// ---------------------------------------------------------------------------
// Email-Outbox module — i18n messages (de-AT)
// ---------------------------------------------------------------------------

export const emailOutboxLocales = {
  'de-AT': {
    admin: {
      emailOutbox: {
        title: 'Email-Outbox',
        subtitle: 'Warteschlange ausgehender Benachrichtigungs-Emails.',
        empty: 'Keine Emails in der Warteschlange.',
        filters: {
          status: 'Status',
          all: 'Alle',
        },
        columns: {
          id: 'ID',
          to: 'Empfänger',
          subject: 'Betreff',
          template: 'Template',
          status: 'Status',
          retries: 'Versuche',
          last_error: 'Letzter Fehler',
          created_at: 'Erstellt',
          sent_at: 'Versandt',
          actions: 'Aktionen',
        },
        status: {
          pending: 'Offen',
          queued: 'In Warteschlange',
          sent: 'Versandt',
          failed: 'Fehlgeschlagen',
        },
        actions: {
          retry: 'Erneut versuchen',
        },
        toast: {
          retry_queued: 'Retry eingereiht.',
          retry_failed: 'Retry fehlgeschlagen.',
        },
      },
    },
  },
} as const;
